import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { PencilSimple, Plus, Trash } from "@phosphor-icons/react";

const tableConfig: FinalTableConfig = {
      index: null,
      actions: [
        {
          name: TableAction.CREATE,
          label: 'create_option',
          showLabel: true,
          allowed: true,
          show: true,
          action: null,
          variant: 'primary',
          icon: <Plus size={20} />
        },
      ],
      rowActions: [
        {
          name: RowAction.EDIT,
          label: 'edit',
          icon: <PencilSimple size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log('edit', element);
          }
        },
        {
          name: RowAction.DELETE,
          label: 'delete',
          icon: <Trash size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log('delete', element);
          }
        }

      ],
      rowConfiguration: {
        class: (element: any) => {
          return null;
        }
      },
      columns: [
        {
          name: 'id',
          label: '#',
          key: 'id',
          type: 'number',
          show: true,
          sortable: true,
        },
        {
          name: 'langs',
          label: 'langs',
          key: 'langs.es',
          type: 'string',
          show: true,
          sortable: true,
        },
        {
          name: 'attribute',
          label: 'attribute',
          key: 'attribute.name',
          type: 'string',
          show: true,
          sortable: true,
        },
       
      ],
      pagination: {
        enabled: true,
        back: true
    }
}
const getConfig: any = (functions: any) => {
    const { getFunction, indexFunction, initializeFunction, prepareRemoveFunction } = functions;
    tableConfig.actions[0].action = () => initializeFunction();
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => getFunction(id);
    tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
    return tableConfig;
}
export default getConfig;